// a library to wrap and simplify api calls
import apisauce from 'apisauce'
import moment from 'moment'
// import {deleteScheduleSubscription} from '../Sagas/SettingsSagas'
// import {getBillingHistory} from '../Sagas/BillingHistorySagas'

// const axios = require('axios')

// our 'constructor'
/* test_back https://7f747c0eca6d.ngrok.io*/
/* production_back https://adspot.dataforest.tech*/
const create = (baseURL = 'https://adspot.dataforest.tech/api') => {
  // ------
  // STEP 1
  // ------
  //
  // Create and configure an apisauce-based api object.
  //
  const accessData = {accessToken: null}

  const api = apisauce.create({
    // base URL is read from the 'constructor'
    baseURL,
    // here are some default headers
    headers: {
      'Content-Type': 'application/json',
    },
    // 10 second timeout...
    timeout: 10000,
  })

  // ------
  // STEP 2
  // ------
  //
  // Define some functions that call the api.  The goal is to provide
  // a thin wrapper of the api layer providing nicer feeling functions
  // rather than 'get', 'post' and friends.
  //
  // I generally don't like wrapping the output at this level because
  // sometimes specific actions need to be take on `403` or `401`, etc.
  //
  // Since we can't hide from that, we embrace it by getting out of the
  // way at this level.
  //

  const serialize = (obj, prefix) => {
    let str = [],
      p
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        //let k = prefix ? prefix + "." + p  : p
        let k = prefix ? prefix : p
        let v = obj[p]
        str.push(v !== null && typeof v === 'object' ? serialize(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v))
      }
    }
    return str.join('&')
  }

  const updateAccessToken = (accessToken, refreshToken) => {
    accessData.accessToken = accessToken
    accessData.refreshToken = refreshToken

    if (accessToken) {
      api.setHeader('Authorization', 'JWT ' + accessToken)
    } else {
      api.setHeader('Authorization', null)
    }
  }

  /*getPublications*/

  const getPublications = (page, page_size, tags, filter, sort, nextPage) => {
    //console.log('getPublications:', page, page_size, tags, filter, sort)
    const query = {}

    if (nextPage) {
      return api.get(nextPage)
    }

    if (page) {
      query.page = page
    }

    if (page_size) {
      query.page_size = page_size
    }

    if (tags) {
      tags.forEach(tag => {
        if (query[tag.name]) {
          query[tag.name].push(tag.value)
        } else {
          if (tag.name === 'likes') {
            query[`${tag.name}_min`] = tag.value[0]
            if (tag.value[1] >= 0 && tag.value[1] < 100000) query[`${tag.name}_max`] = tag.value[1]
          } else if (tag.name === 'comments' || tag.name === 'shares' || tag.name === 'views') {
            query[`${tag.name}_count_min`] = tag.value[0]
            if (tag.value[1] >= 0 && tag.value[1] < 100000) query[`${tag.name}_count_max`] = tag.value[1]
          } else if (tag.name === 'created') {
            query[`${tag.name}_after`] = tag.value[0]
            query[`${tag.name}_before`] = tag.value[1]
          } else if (tag.name === 'seen') {
            query[`last_seen_date_after`] = tag.value[0]
            query[`last_seen_date_before`] = tag.value[1]
          } else if (tag.name === 'comments_') {
            query['comments'] = [tag.value]
          } else {
            query[tag.name] = [tag.value]
          }
        }
      })
    }

    if (filter) {
      if (filter.is_deleted) {
        query.is_deleted = filter.is_deleted
      }
      if (filter.search) {
        query.search = filter.search
      }
    }

    if (sort) {
      if (sort === 'comments' || sort === 'shares') {
        query.ordering = '-' + sort + '_count'
      } else if (sort === 'most_recent') {
        query.ordering = '-created'
      } else if (sort === 'oldest') {
        query.ordering = 'created'
      } else {
        query.ordering = '-' + sort
      }
    }

    return api.get('/ad_publications/?' + serialize(query))
  }

  const getFollowingPublications = (page, page_size, tags, filter, sort, nextPage) => {
    //console.log('getFollowingPublications:', page, page_size, tags, filter, sort)
    const query = {}
    if (nextPage) {
      return api.get(nextPage)
    }

    if (page) {
      query.page = page
    }

    if (page_size) {
      query.page_size = page_size
    }

    if (tags) {
    }

    if (filter) {
      if (filter.created && filter.created.length) {
        query[`created_after`] = moment(filter.created[0]).format('YYYY-MM-DD')
        query[`created_before`] = moment(filter.created[1]).format('YYYY-MM-DD')
      }
      if (filter.seen && filter.seen.length) {
        query[`last_seen_date_after`] = moment(filter.seen[0]).format('YYYY-MM-DD')
        query[`last_seen_date_before`] = moment(filter.seen[1]).format('YYYY-MM-DD')
      }
    }

    if (sort) {
      if (sort === 'comments' || sort === 'shares') {
        query.ordering = '-' + sort + '_count'
      } else if (sort === 'most_recent') {
        query.ordering = '-created'
      } else if (sort === 'oldest') {
        query.ordering = 'created'
      } else {
        query.ordering = '-' + sort
      }
    }

    return api.get('/ad_publications/followings/?' + serialize(query))
  }

  const getAdvertiserPublications = (id, page, page_size, tags, filter, sort, nextPage) => {
    const query = {}

    if (nextPage) {
      return api.get(nextPage)
    }

    if (page) {
      query.page = page
    }

    if (page_size) {
      query.page_size = page_size
    }

    return api.get(`/ad_publications/authors/${id}/?` + serialize(query))
  }

  const getListPublications = (id, page, page_size, tags, filter, sort, nextPage) => {
    const query = {}

    if (nextPage) {
      return api.get(nextPage)
    }

    if (page) {
      query.page = page
    }

    if (page_size) {
      query.page_size = page_size
    }

    return api.get(`/top_performing_products/admin/lists/${id}/?` + serialize(query))
  }

  const deleteListPublications = (id, data) => {
    return api.delete(`/top_performing_products/admin/lists/${id}/${data.join('-')}/`)
  }

  const deleteRestorePublication = (id, data) => {
    return api.patch(`/ad_publications/${id}/`, data)
  }

  const getPreparedPublications = (page, page_size, tags, filter, sort, nextPage) => {
    //console.log('getFollowingPublications:', page, page_size, tags, filter, sort)
    const query = {}

    if (nextPage) {
      return api.get(nextPage)
    }

    if (page) {
      query.page = page
    }

    if (page_size) {
      query.page_size = page_size
    }

    return api.get('/top_performing_products/admin/prepared_posts/?' + serialize(query))
  }

  const getScheduledPublications = (page, page_size, tags, filter, sort, nextPage) => {
    //console.log('getFollowingPublications:', page, page_size, tags, filter, sort)
    const query = {}

    if (nextPage) {
      return api.get(nextPage)
    }

    if (page) {
      query.page = page
    }

    if (page_size) {
      query.page_size = page_size
    }

    if (filter) {
      if (filter.date) query.schedule__gte = `${filter.date} 18:00:00`
    }

    return api.get('/top_performing_products/admin/scheduled_posts/?' + serialize(query))
  }

  const getFollowingSavedCount = () => {
    return api.get('/ad_publications/following_saved_count/')
  }

  const getPublication = id => {
    return api.get(`/ad_publications/${id}/`)
  }

  const getPublicationMoreAds = (id, page, page_size) => {
    const query = {}
    if (page) {
      query.page = page
    }

    if (page_size) {
      query.page_size = page_size
    }

    return api.get(`/ad_publications/${id}/more_ads/?${serialize(query)}`)
  }

  const savePublication = (publicationId, folderId) => {
    return api.post(`/ad_publications/${publicationId}/save/${folderId ? `${folderId}/` : ''}`)
  }

  const followAuthor = authorId => {
    return api.post(`/ad_publications/authors/${authorId}/follow/`)
  }

  const getReportReasons = () => {
    return api.get('/ad_publications/report_reasons/')
  }

  const sendReport = (id, data) => {
    return api.post(`/ad_publications/${id}/report/`, data)
  }

  const getTickets = (page, page_size, sort, nextPage, search) => {
    const query = {}
    if (search) {
      return api.get(`/admin_panel/tickets/?search=${encodeURIComponent(search)}`)
    }
    if (nextPage) {
      return api.get(nextPage)
    }
    if (page) {
      query.page = page
    }
    if (page_size) {
      query.page_size = page_size
    }

    if (sort) {
      if (sort === 'ascend') {
        query.ordering = '-created'
      } else if (sort === 'descend') {
        query.ordering = 'created'
      }
    }
    return api.get('/admin_panel/tickets/?' + serialize(query))
  }

  const getTicketId = id => {
    return api.get(`/admin_panel/tickets/${id}/`)
  }

  const getReports = (page, page_size, sort, nextPage, search) => {
    const query = {}
    if (search) {
      return api.get(`/admin_panel/report_tickets/?search=${encodeURIComponent(search)}`)
    }
    if (nextPage) {
      return api.get(nextPage)
    }
    if (page) {
      query.page = page
    }
    if (page_size) {
      query.page_size = page_size
    }
    if (sort) {
      if (sort === 'ascend') {
        query.ordering = '-created'
      } else if (sort === 'descend') {
        query.ordering = 'created'
      }
    }
    return api.get('/admin_panel/report_tickets/?' + serialize(query))
  }
  const getReportId = id => {
    return api.get(`/admin_panel/report_tickets/${id}/`)
  }
  const deleteTicket = id => {
    return api.delete(`/admin_panel/tickets/${id}/`)
  }

  const deleteReport = id => {
    return api.delete(`/admin_panel/report_tickets/${id}/`)
  }

  const getAdvertisers = filter => {
    const query = {}
    if (filter.nextPage) {
      return api.get(filter.nextPage)
    }
    if (filter.page) {
      query.page = filter.page
    }
    if (filter.page_size) {
      query.page_size = filter.page_size
    }
    if (filter.search) {
      query.search = filter.search
    }
    if (filter.is_deleted) {
      query.is_deleted = filter.is_deleted
    }
    return api.get(`/ad_publications/followings/authors/?${serialize(query)}`)
    //return api.get(`/ad_publications/authors/?${serialize(query)}`)
  }

  const getFollowingsAdvertisers = () => {
    return api.get(`/ad_publications/followings/authors/`)
  }

  const getAdvertiser = id => {
    return api.get(`/ad_publications/followings/authors/${id}/`)
    //return api.get(`/ad_publications/authors/${id}/`)
  }

  const deleteRestoreAdvertiser = (id, data) => {
    return api.patch(`/ad_publications/authors/${id}/`, data)
  }

  const getFolders = (page, page_size, search, filter, sort, nextPage) => {
    const query = {}

    /*if(nextPage){
            return api.get(nextPage)
        }*/

    if (page) {
      query.page = page
    }

    if (page_size) {
      query.page_size = page_size
    }

    return api.get('/ad_publications/folders/?' + serialize(query))
  }

  const getFolderPublications = (id, page, page_size, search, filter, sort, nextPage) => {
    const query = {}

    if (nextPage) {
      return api.get(nextPage)
    }

    if (page) {
      query.page = page
    }

    if (page_size) {
      query.page_size = page_size
    }

    if (search) {
    }

    if (filter) {
      if (filter.created && filter.created.length) {
        query[`created_after`] = moment(filter.created[0]).format('YYYY-MM-DD')
        query[`created_before`] = moment(filter.created[1]).format('YYYY-MM-DD')
      }
      if (filter.seen && filter.seen.length) {
        query[`last_seen_date_after`] = moment(filter.seen[0]).format('YYYY-MM-DD')
        query[`last_seen_date_before`] = moment(filter.seen[1]).format('YYYY-MM-DD')
      }
    }

    if (sort) {
      if (sort === 'comments' || sort === 'shares') {
        query.ordering = '-' + sort + '_count'
      } else if (sort === 'most_recent') {
        query.ordering = '-created'
      } else if (sort === 'oldest') {
        query.ordering = 'created'
      } else {
        query.ordering = '-' + sort
      }
    }

    return api.get(`/ad_publications/folders/${id}/adpublications/?${serialize(query)}`)
  }

  const getFolder = id => {
    return api.get(`/ad_publications/folders/${id}/`)
  }

  const updateFolder = data => {
    const newData = {...data}

    if (data.id) {
      delete newData.id
      return api.put(`/ad_publications/folders/${data.id}/`, newData)
    } else {
      return api.post(`/ad_publications/folders/`, newData)
    }
  }

  const deleteFolder = folderId => {
    return api.delete(`/ad_publications/folders/${folderId}/`)
  }

  const makeDefaultFolder = folderId => {
    return api.post(`/ad_publications/folders/${folderId}/make_default/`)
  }

  const getFilters = () => {
    return api.get('/ad_publications/filters/')
  }

  const saveFilters = data => {
    const newData = {...data}
    //delete newData.id;
    return api.post(`/ad_publications/search_presets/`, newData)
  }

  const loadFilters = () => {
    return api.get(`/ad_publications/search_presets/`)
  }

  const updateFilters = data => {
    const newData = {...data}
    delete newData.id

    return api.put(`/ad_publications/search_presets/${data.id}/`, newData)
  }

  const deleteFilters = id => {
    return api.delete(`/ad_publications/search_presets/${id}/`)
  }

  const getPerformanceChart = (id, chart_type, period) => {
    return api.get(`/ad_publications/${id}/graph/?field=${chart_type}_count&period=${period}`)
  }

  const getStatusChart = (id, period) => {
    return api.get(`/ad_publications/${id}/graph/?field=status&period=${period}`)
  }

  const getFiltersInterestLanguage = () => {
    return api.get('/interests/languages/')
  }

  const getFiltersInterestCategory = language => {
    const query = {}

    if (language) {
      query.language = language
    }

    return api.get(`/interests/tree/?${serialize(query)}`)
  }

  const getFiltersInterest = (language, search) => {
    const query = {}

    if (language) {
      query.language = language
    }

    if (search) {
      query.name = search
    }

    return api.get(`/interests/?${serialize(query)}`)
  }

  const getInterests = (id, page, page_size, sort_field, sort_order, filter) => {
    const query = {}
    if (page) {
      query.page = page
    }

    if (page_size) {
      query.page_size = page_size
    }

    if (sort_field) {
      query.ordering = (sort_order === 'descend' ? '-' : '') + sort_field
    }

    if (filter) {
      if (filter.audience_min) query.audience__gte = filter.audience_min
      if (filter.audience_max) query.audience__lte = filter.audience_max
      if (filter.language) query.language = filter.language
    }

    return api.get(`/interests/suggestions/${id}/?${serialize(query)}`)
  }

  const getInterestFile = (id, page, page_size, sort_field, sort_order, filter) => {
    const headers = {
      Accept: `text/csv`,
    }

    const query = {}
    if (page) query.page = page
    if (page_size) query.page_size = page_size
    if (sort_field) query.ordering = (sort_order === 'descend' ? '-' : '') + sort_field

    if (filter) {
      if (filter.audience_min) query.audience__gte = filter.audience_min
      if (filter.audience_max) query.audience__lte = filter.audience_max
    }

    return api.get(`/interests/export/${id}/?${serialize(query)}`, {}, {headers})
  }

  const getInterestExample = language => {
    //return api.get(`/interests/examples/`)
    return api.get(`/interests/examples/?language=${language}`)
  }

  const getLists = (sort_field, sort_order) => {
    const query = {}
    if (sort_field) query.ordering = (sort_order === 'descend' ? '-' : '') + sort_field

    return api.get(`/top_performing_products/admin/lists/?${serialize(query)}`)
  }

  const restoreList = id => {
    return api.post(`/top_performing_products/admin/lists/${id}/restore/`)
  }

  const getPublicationCreate = id => {
    return api.get(`/top_performing_products/admin/performing_publication/${id}/`)
  }

  const savePublicationCreate = (id, data) => {
    const newData = {is_edited: true}

    if (data.product_title) newData.product_title = data.product_title
    if (data.product_description) newData.product_description = data.product_description
    if (data.tags)
      newData.tags = data.tags
        .split(',')
        .filter(tag => !!tag)
        .map(str => str.trim())
    newData.schedule = data.schedule ? `${data.schedule} 18:00:00` : null

    return api.put(`/top_performing_products/admin/performing_publication/${id}/`, newData)
  }

  const saveSeller = (id, data) => {
    return api.post(`/top_performing_products/admin/performing_products/seller/`, {...data, adpublication: id})
  }

  const updateSeller = (id, data) => {
    return api.put(`/top_performing_products/admin/performing_products/seller/${id}/`, {...data})
  }

  const deleteSeller = id => {
    return api.delete(`/top_performing_products/admin/performing_products/seller/${id}/`)
  }

  const getPages = () => {
    return api.get(`/suggest_a_feature/pages/`)
  }

  const sendSuggest = data => {
    const headers = {
      'Content-Type': 'multipart/form-data',
    }

    const form = new FormData()
    for (const key in data) {
      form.append(key, data[key])
    }

    return api.post(`/suggest_a_feature/suggest/`, form, {headers})
  }

  const sendHelp = data => {
    const headers = {
      'Content-Type': 'multipart/form-data',
    }

    const form = new FormData()
    for (const key in data) {
      form.append(key, data[key])
    }

    return api.post(`/suggest_a_feature/help/`, form, {headers})
  }

  const deletePublicationCreate = id => {
    return api.delete(`/top_performing_products/admin/performing_publication/${id}/`)
  }

  const saveSupplier = (id, data) => {
    const headers = {
      'Content-Type': 'multipart/form-data',
    }

    const form = new FormData()
    form.append('adpublication', id)
    form.append('supplier', data.supplier)
    form.append('min_price', data.min_price)
    form.append('max_price', data.max_price)
    form.append('product', data.product)
    form.append('page_link', data.page_link)
    form.append('media', data.media)

    return api.post(`/top_performing_products/admin/performing_products/supplier/`, form, {headers})
  }

  const updateSupplier = (id, data) => {
    const headers = {
      'Content-Type': 'multipart/form-data',
    }

    const form = new FormData()
    if (id) form.append('adpublication', id)
    if (data.supplier) form.append('supplier', data.supplier)
    if (data.min_price) form.append('min_price', data.min_price)
    if (data.max_price) form.append('max_price', data.max_price)
    if (data.product) form.append('product', data.product)
    if (data.page_link) form.append('page_link', data.page_link)
    if (data.media) form.append('media', data.media)

    return api.put(`/top_performing_products/admin/performing_products/supplier/${id}/`, form, {headers})
  }

  const deleteSupplier = id => {
    return api.delete(`/top_performing_products/admin/performing_products/supplier/${id}/`)
  }

  const saveMedia = (id, data) => {
    const headers = {
      'Content-Type': 'multipart/form-data',
    }

    const form = new FormData()
    if (data.adpublication) form.append('adpublication', data.adpublication)
    if (data.supplier) form.append('supplier', data.supplier)
    if (data.min_price) form.append('min_price', data.min_price)
    if (data.max_price) form.append('max_price', data.max_price)
    if (data.product) form.append('product', data.product)
    if (data.page_link) form.append('page_link', data.page_link)
    if (data.media) form.append('media', data.media)

    return api.post(`/top_performing_products/admin/performing_publication/media/`, form, {headers})
  }

  const updateMedia = (id, data) => {
    const headers = {
      'Content-Type': 'multipart/form-data',
    }

    const form = new FormData()
    form.append('adpublication', data.adpublication)
    form.append('media', data.media)

    return api.put(`/top_performing_products/admin/performing_publication/media/${id}/`, form, {headers})
  }

  const deleteMedia = id => {
    return api.delete(`/top_performing_products/admin/performing_publication/media/${id}/`)
  }

  const getFiltersTopPerforming = () => {
    return api.get('/ad_publications/filters/')
  }

  // TOP PERFOMING PAGE

  const getTopPerforming = (page, page_size, filter, sort, nextPage) => {
    const query = {}

    if (nextPage) {
      //return api.get(nextPage)
    }
    if (page) {
      query.page = page
    }
    if (page_size) {
      query.page_size = page_size
    }

    if (filter) {
      for (const key in filter) {
        let value = filter[key]
        if (query[key]) {
          query[key].push(value)
        } else {
          if (key === 'likes' && value?.length) {
            query[`${key}_min`] = value[0]
            query[`${key}_max`] = value[1]
          } else if ((key === 'comments' || key === 'shares') && value?.length) {
            query[`${key}_count_min`] = value[0]
            query[`${key}_count_max`] = value[1]
          } else if (key === 'created' && value?.length) {
            query[`${key}_after`] = value[0]
            query[`${key}_before`] = value[1]
          } else if (key === 'views' && value?.length) {
            // query[`${key}_count_min`] = value[0]
            // query[`${key}_count_max`] = value[1]
          } else if (key === 'seen' && value?.length) {
            query[`last_seen_date_after`] = value[0]
            query[`last_seen_date_before`] = value[1]
          } else if (key === 'comments_' && value) {
            query['comments'] = value
          } else if (key === 'price_range' && value?.length) {
            query['price_range__gt'] = value[0]
            query['price_range__lt'] = value[1]
          } else if (key && value?.length) {
            query[key] = value
          }
        }
      }
    }
    if (sort) {
      if (sort === 'comments' || sort === 'shares') {
        query.ordering = '-' + sort + '_count'
      } else if (sort === 'most_recent') {
        query.ordering = '-created'
      } else if (sort === 'oldest') {
        query.ordering = 'created'
      } else {
        query.ordering = '-' + sort
      }
    }
    return api.get('/top_performing_products/?' + serialize(query))
  }
  const getTopPerformingId = id => api.get(`/top_performing_products/${id}/`)

  const followAuthorTpp = authorId => api.post(`/ad_publications/authors/${authorId}/follow/`)
  const saveTopPerforming = (publicationId, folderId) =>
    api.post(`/ad_publications/${publicationId}/save/${folderId ? `${folderId}/` : ''}`)
  const getReportTppReasons = () => api.get('/ad_publications/report_reasons/')
  const sendTppReport = (id, data) => api.post(`/ad_publications/${id}/report/`, data)

  // USER

  const getUser = userId => {
    return api.get(`/user/user/${userId}/`)
  }

  const updateUser = data => {
    const newData = {...data}
    delete newData.id

    if (data.media) {
      const headers = {
        'Content-Type': 'multipart/form-data',
      }

      const form = new FormData()
      form.append('icon', data.media)

      return api.put(`/user/user/${data.id}/`, form, {headers})
    }

    return api.put(`/user/user/${data.id}/`, newData)
  }

  const getPermissionsPages = () => {
    return api.get(`/admin_panel/permissions/`)
  }

  const getPermissions = (page, page_size, filter) => {
    const query = {}
    if (page) query.page = page
    if (page_size) query.page_size = page_size
    if (filter.pages) query.sort = filter.pages

    return api.get(`/admin_panel/workers/?${serialize(query)}`)
  }

  const getPermission = id => {
    return api.get(`/admin_panel/workers/${id}/`)
  }

  const savePermissions = data => {
    if (data.id) {
      const newData = {...data}
      delete newData.id

      return api.put(`/admin_panel/workers/${data.id}/`, newData)
    } else {
      return api.post(`/admin_panel/workers/`, data)
    }
  }

  const deletePermissions = id => {
    return api.delete(`/admin_panel/workers/${id}/`)
  }

  const changeUserEmail = data => {
    return api.post(`/user/user/change_email/`, data)
  }

  const confirmChangeEmail = data => {
    return api.post(`/user/user/confirm_change_email/`, data)
  }

  const getCountries = () => {
    return api.get(`/payment/countries/`)
  }

  const getSubscriptions = () => {
    return api.get(`/payment/subscriptions/`)
  }

  const buySubscription = data => {
    return api.post(`/payment/create/subscription/`, data)
  }

  const updateSubscription = data => {
    return api.post(`/payment/change/subscription/`, data)
  }

  const saveCompanyInfo = data => {
    if (data.id) {
      const newData = {...data}
      delete newData.id
      return api.put(`/payment/company/${data.id}/`, newData)
    }
    return api.post(`/payment/company/`, data)
  }

  const deleteScheduledSubscription = () => {
    return api.post(`/payment/cancel/scheduled_subscription/`)
  }

  const savePaymentMethod = data => {
    return api.post(`/payment/insert/payment_method/`, data)
  }

  const getBillingHistory = (page, page_size, id) => {
    const query = {}
    if (page) query.page = page
    if (page_size) query.page_size = page_size
    if (id) {
      return api.get(`admin_panel/customers/${id}/billing/?${serialize(query)}`)
    }
    return api.get(`/payment/billing/?${serialize(query)}`)
  }

  const getNotifications = () => {
    return api.get('/notifications/')
  }

  const updateNotifications = data => {
    return api.put('/notifications/', data)
  }

  const getCustomers = (page, page_size, sort, search) => {
    const query = {}
    if (search) {
      query.search = search
      //return api.get(`/admin_panel/customers/?search=${encodeURIComponent(search)}`)
    }
    if (page) {
      query.page = page
    }
    if (page_size) {
      query.page_size = page_size
    }
    if (sort?.order) {
      query.ordering = (sort.order === 'descend' ? '-' : '') + sort.field
    } else {
      query.ordering = '-created'
    }
    return api.get('/admin_panel/customers/?' + serialize(query))
  }
  const getCustomerId = id => {
    return api.get(`/admin_panel/customers/${id}/`)
  }

  const deleteCustomer = id => {
    return api.delete(`/admin_panel/customers/${id}/`)
  }

  const updateCustomer = (id, data) => {
    return api.put(`/admin_panel/customers/${id}/`, data)
  }

  const checkDiscountCode = code => {
    return api.get(`/payment/discount_code/?code=${code}`)
  }

  const checkStatusPayment = paymentId => {
    return api.get(`/payment/check_status/${paymentId}/`)
  }

  // ------
  // STEP 3
  // ------
  //
  // Return back a collection of functions that we would consider our
  // interface.  Most of the time it'll be just the list of all the
  // methods in step 2.
  //
  // Notice we're not returning back the `api` created in step 1?  That's
  // because it is scoped privately.  This is one way to create truly
  // private scoped goodies in JavaScript.
  //
  return {
    // a list of the API functions from step 2
    updateAccessToken,

    getPublications,
    getFollowingPublications,
    getFolderPublications,
    getPublication,
    getPublicationMoreAds,
    savePublication,
    followAuthor,
    getReportReasons,
    sendReport,
    getAdvertiserPublications,
    getPreparedPublications,
    getScheduledPublications,
    getListPublications,
    deleteListPublications,
    deleteRestorePublication,

    getFollowingSavedCount,

    getFollowingsAdvertisers,
    getAdvertisers,
    getAdvertiser,
    deleteRestoreAdvertiser,

    getFolders,
    getFolder,
    updateFolder,
    deleteFolder,
    makeDefaultFolder,

    getFilters,
    saveFilters,
    loadFilters,
    updateFilters,
    deleteFilters,

    getPerformanceChart,
    getStatusChart,

    getFiltersInterestLanguage,
    getFiltersInterestCategory,
    getFiltersInterest,

    getInterests,
    getInterestFile,
    getInterestExample,

    getLists,
    restoreList,

    getPublicationCreate,
    savePublicationCreate,
    deletePublicationCreate,
    saveSeller,
    updateSeller,
    deleteSeller,

    getPages,
    sendSuggest,
    sendHelp,
    getTickets,
    getTicketId,
    deleteTicket,
    getReports,
    getReportId,
    deleteReport,

    getTopPerforming,
    getTopPerformingId,
    followAuthorTpp,
    saveTopPerforming,
    getReportTppReasons,
    sendTppReport,

    saveSupplier,
    updateSupplier,
    deleteSupplier,
    saveMedia,
    updateMedia,
    deleteMedia,
    getFiltersTopPerforming,

    getUser,
    updateUser,
    changeUserEmail,
    confirmChangeEmail,

    getPermissions,
    getPermission,
    savePermissions,
    deletePermissions,
    getPermissionsPages,

    getCountries,
    getSubscriptions,
    buySubscription,
    updateSubscription,
    saveCompanyInfo,
    deleteScheduledSubscription,
    savePaymentMethod,

    getBillingHistory,
    getNotifications,
    updateNotifications,

    getCustomers,
    getCustomerId,
    deleteCustomer,
    updateCustomer,

    checkDiscountCode,
    checkStatusPayment,
  }
}

// let's return back our create method as the default.
export default create()
